export const nameAvatarWrapper = {
    alignItems: 'center',
    display: 'flex',
    gap: '5px',
}

export const dotWrapper = {
    borderRadius: '50%',
    height: '10px',
    minWidth: '10px',
    variants: {
        state: {
            disabled: {
                backgroundColor: '$tableCellStatusNeutral',
                opacity: 0.1,
            },
            half: {background: 'linear-gradient(90deg, $tableCellStatusPositive 50%, $tableCellStatusNegative 50%)'},
            negative: {backgroundColor: '$tableCellStatusNegative'},
            neutral: {backgroundColor: '$tableCellStatusNeutral'},
            positive: {backgroundColor: '$tableCellStatusPositive'},
        },
    },
    width: '10px',
}
